import { FeedbackStats, ItemModel } from "lib/services/catalogical-models";
import { forEach } from "lodash";

import { CatalogItemSimplified } from "./catalog-types";

/**
 * Interface for the item values of the catalogical request
 */
export interface CatalogicalItem extends ItemModel {
  name: string;
  status?: "sanctioned" | "unsanctioned" | "unavailable";
  subtype: string;
  sku: string;
  price?: {
    amount: number;
    currency: string;
  };
  external_button_text?: string;
  order_redirect_url?: string;
  manufacturer: string;
  shortName: string;
  description?: string;
  shortDescription?: string;
  parentTaxonomyItemId?: string;
  isTaxonomyParent?: boolean;
  logoUrl?: string;
  recurrence?: string;
  retailPrice?: {
    amount: number;
    currency: string;
  };
  order_workflow?: string;
  eta_days?: number;
  restock_threshold?: number;
  has_stock?: boolean;
  os?: string[];
  licenseActivationInstructions?: string;
  licenseType?: "single_seat" | "multi_seat";
  resellerInformation?: {
    quoteNumber: string;
    quoteDate: string;
  };
  categories?: string[];
  availabilityRestrictions?: {
    level: "building" | "country" | "region" | "level" | "organization" | "posix_group";
    values: string[];
  }[];
  references?: {
    websiteUrl: string;
    moreDetailsUrl: string;
    orderRedirectUrl: string;
    productDownloadUrl: string;
  };
  tags?: string[];
  itptClassification?: string;
  specifications?: { key: string; value: any }[];
  feedback?: FeedbackStats;
}

/**
 * Interface for the answer of the pagination and items information
 */
export interface paginationResponse {
  limit: number;
  offset: number;
  total: number;
}

/**
 * Interface for the answer of specific taxonomy Id request.
 */
export interface CatalogicalGetItemResponse {
  item: CatalogicalItem;
}

/**
 * Interface for the service response that contains an array of catalog request responses and Pagination and items information.
 * @deprecated
 */
export interface CatalogicalGetAllItemsResponse {
  data: CatalogicalItem[];
  pagination: paginationResponse;
}

/**
 * Interface for the possible query parameters of a catalogical request
 */
export interface CatalogicalRequestContent {
  limit?: number | undefined;
  offset?: number | undefined;
  sortBy?: string | undefined;
  sortDirection?: string | undefined;
  fuzzy?: boolean | undefined;
  keywords?: string | undefined;
  filter?: string | undefined;
  semanticSearch?: string | undefined;
  itemType?: string;
  useSemanticSearch?: boolean;
  searchQuery?: string;
  excludeFields?: string;
  bypass?: boolean;
}

/**
 * enum of Possible item status
 */
export enum ItemStatus {
  sanctioned = "sanctioned",
  unavailable = "unavailable",
  unsanctioned = "unsanctioned",
}

export interface CatalogItemSimplifiedWithRecommendations extends CatalogItemSimplified {
  recommendations?: string;
}

/**
 * Function to convert CatalogicalItems into an array of CatalogItemSimplified
 */
export const convertToSimplified = (catalogicalItems: CatalogicalItem[]): CatalogItemSimplified[] => {
  return catalogicalItems.map(
    (item) =>
      ({
        ...item,
        logoImageUrl: item.logoUrl,
        itemId: item.taxonomyId,
        price: `${item.price?.amount}`,
      } as unknown as CatalogItemSimplified)
  );
};
